import { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from 'reactstrap';

const DeleteMoveInOutInspectionConfirmationModal = ({
  open,
  onClose,
  onDelete,
  inspectionLog,
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await onDelete?.();
      onClose();
    } catch (error) {
      console.error('Delete failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const getInspectionDate = () => {
    const mi = inspectionLog?.move_in;
    const mo = inspectionLog?.move_out;

    return (
      mi?.["1"]?.inspection_date ||
      mi?.["3"]?.inspection_date ||
      mo?.["1"]?.inspection_date ||
      mo?.["3"]?.inspection_date
    );
  };

  const inspectionDate = getInspectionDate();
  const formattedDate = inspectionDate
    ? new Date(inspectionDate).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : 'this inspection';

  const addressInfo = inspectionLog?.property_details;
  const buildingName =
    addressInfo?.address ||
    addressInfo?.property_name ||
    'this property';

  const unitNumber = addressInfo?.unit_number;

  return (
    <Modal
      isOpen={open}
      toggle={onClose}
      centered
      className="move-in-out-inspection-dialog"
    >
      <ModalHeader toggle={onClose}>Confirm Deletion</ModalHeader>

      <ModalBody>
        <p className="mb-0">
          Are you sure you want to delete the{' '}
          <strong>Move-In / Move-Out Inspection Log</strong> for{' '}
          <strong>
            {buildingName}
            {unitNumber ? ` (Unit ${unitNumber})` : ''}
          </strong>{' '}
          dated <strong>{formattedDate}</strong>?
          <br />
          <small className="text-muted">
            This action cannot be undone.
          </small>
        </p>
      </ModalBody>

      <ModalFooter>
        <Button
          outline
          color="secondary"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>

        <Button
          color="danger"
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading && <Spinner size="sm" className="me-2" />}
          {loading ? 'Deleting...' : 'Delete Inspection'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { DeleteMoveInOutInspectionConfirmationModal };